const TEMPLATE = `
<section id="expertises-section" class="expertises-section" data-section="expertises-section"></section>
`;

class BmlExpertiseList extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-expertise-list', BmlExpertiseList);
